export interface ShareArtifactWithOrgsRequest {
  publicId: string
  orgs: { id: string; name?: string }[]
}
